'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$Unrouteable$() {
  this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodec$lzy2 = null;
  this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodecbitmap$2 = false;
}
export { $c_Lapp_pages_AppPage$Unrouteable$ as $c_Lapp_pages_AppPage$Unrouteable$ };
$c_Lapp_pages_AppPage$Unrouteable$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$Unrouteable$.prototype.constructor = $c_Lapp_pages_AppPage$Unrouteable$;
/** @constructor */
function $h_Lapp_pages_AppPage$Unrouteable$() {
}
export { $h_Lapp_pages_AppPage$Unrouteable$ as $h_Lapp_pages_AppPage$Unrouteable$ };
$h_Lapp_pages_AppPage$Unrouteable$.prototype = $c_Lapp_pages_AppPage$Unrouteable$.prototype;
$c_Lapp_pages_AppPage$Unrouteable$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.hashCode__I = (function() {
  return 1904341130;
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.toString__T = (function() {
  return "Unrouteable";
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.productPrefix__T = (function() {
  return "Unrouteable";
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodecbitmap$2)) {
    var configuration$proxy2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
    var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var \u03b41$ = $m_Lapp_pages_AppPage$Unrouteable$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => \u03b41$));
    }));
    var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$()));
    var defaults = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(values);
    this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodec$lzy2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredCodec$$anon$3(configuration$proxy2, "Unrouteable", fromProduct, decoders, encoders, labels, defaults);
    this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodecbitmap$2 = true;
  }
  return this.Lapp_pages_AppPage$Unrouteable$__f_derived$CirceCodec$lzy2;
});
$c_Lapp_pages_AppPage$Unrouteable$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_pages_AppPage$Unrouteable$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$Unrouteable$, "app.pages.AppPage$Unrouteable$", ({
  Lapp_pages_AppPage$Unrouteable$: 1,
  Lapp_pages_AppPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_pages_AppPage$Unrouteable$ as $d_Lapp_pages_AppPage$Unrouteable$ };
var $n_Lapp_pages_AppPage$Unrouteable$;
function $m_Lapp_pages_AppPage$Unrouteable$() {
  if ((!$n_Lapp_pages_AppPage$Unrouteable$)) {
    $n_Lapp_pages_AppPage$Unrouteable$ = new $c_Lapp_pages_AppPage$Unrouteable$();
  }
  return $n_Lapp_pages_AppPage$Unrouteable$;
}
export { $m_Lapp_pages_AppPage$Unrouteable$ as $m_Lapp_pages_AppPage$Unrouteable$ };
//# sourceMappingURL=app.pages.-App-Page$-Unrouteable$.js.map
